module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/thumb_class-f8b4d25d11477e6047d25b90242f6d02.png";